module.exports = __webpack_public_path__ + "static/ISO9001Logo-919797ba36c5d989e41a11a51e70a7b7.svg";